import { useLocalSettings } from "@hooks/useStorage";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import React, { useMemo } from "react";
import * as themes from "../themes";

// interface ThemeContextValue {
//   set: () => void;
// }

// const ThemeContext = createContext<ThemeContextValue>({} as ThemeContextValue);
// ThemeContext.displayName = "ThemeContext";

export const ThemeContextProvider = ({ children }: { children: React.ReactNode }) => {
  const { settings } = useLocalSettings();
  // const [state] = useState<ThemeContextValue>({
  //   set: () => 1,
  // });

  const theme = useMemo(() => {
    const t = themes[settings.theme];
    return t || themes.dark;
  }, [settings.theme]);

  return (
    // <ThemeContext.Provider value={state}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
    // </ThemeContext.Provider>
  );
};

// export const useThemeContext = () => useContext(ThemeContext);
